import * as d3 from 'd3';

// fixme この辺はdataなどに持たせた方がいい気がする
const def_blindspot = 120;
const blindspot = {
  id: 'fl_blindspot',
  name: 'Blind Spot',
  range: [1, 360],
  value: def_blindspot,
};

const def_R_coll = 1;
const R_coll = {
  id: 'fl_rcoll',
  name: 'Collision Radius',
  range: [0, 2],
  value: def_R_coll,
};

const def_R_attract = 15;
const R_attract = {
  id: 'fl_rattract',
  name: 'Attraction Radius',
  range: [0, 20],
  value: def_R_attract,
};

const def_R_align = 5;
const R_align = {
  id: 'fl_ralign',
  name: 'Alignment Radius',
  range: [0, 10],
  value: def_R_align,
};

const def_noise_heading = 15;
const noise_heading = {
  id: 'fl_noise_heading',
  name: 'Wiggle',
  range: [0, 30],
  value: def_noise_heading,
};

const def_speed = 0.64; //variation in individuals' speeds
const speed = {
  id: 'fl_speed',
  name: 'Speed',
  range: [0, 1],
  value: def_speed,
};

const epsilon = 0.2; // angular increment
const dt = 1;
// const MENU_X = 37;
const blind = Math.cos(((180 - blindspot.value / 2) / 180) * Math.PI);

let wanted_x = 0; // this is the target direction
let wanted_y = 0; // an agent wants to move to

// helps translate degrees and radian
const g2r = d3
  .scaleLinear()
  .domain([0, 360])
  .range([0, 2 * Math.PI]);

const r2g = d3
  .scaleLinear()
  .range([0, 360])
  .domain([0, 2 * Math.PI]);

class Swim {
  static fixTheta(agent, agents) {
    // these are the agents in the collision radius apart from the reference agent
    let colliders = [];

    colliders = agents.filter((d) => {
      const dx = agent.x - d.x;
      const dy = agent.y - d.y;
      return Math.sqrt(dx * dx + dy * dy) < R_coll.value && d.id != agent.id;
    });

    // either collisions occur or alignment and attraction occur
    if (colliders.length > 0) {
      wanted_x =
        agent.x -
        d3.mean(colliders, (d) => {
          return d.x;
        });
      wanted_y =
        agent.y -
        d3.mean(colliders, (d) => {
          return d.y;
        });
    }

    // if no collisions occur agents align with agents in their alignment radius
    // and are attracted to the the agents in the attraction radius
    else {
      const vx = Math.cos(g2r(agent.theta));
      const vy = Math.sin(g2r(agent.theta));
      const vabs = Math.sqrt(vx * vx + vy * vy);

      // the interaction set are all agents within the larger attraction radius
      // and outside the blind spot
      const interaction_set = agents.filter((d) => {
        const dx = d.x - agent.x;
        const dy = d.y - agent.y;
        d.r = Math.sqrt(dx * dx + dy * dy);
        const sight = (dx * vx + dy * vy) / (vabs * d.r);

        return d.r < R_attract.value && sight > blind && d.id != agent.id;
      });

      // now we separate them into the agents to align with and those to be attracted to
      const n_orient = interaction_set.filter((d) => {
        return d.r < R_align.value;
      });
      const n_attract = interaction_set.filter((d) => {
        return d.r > R_align.value;
      });

      let theta_orient = agent.theta;
      let theta_attract = agent.theta;

      const L_orient = n_orient.length;
      const L_attract = n_attract.length;

      if (L_orient > 0) {
        const mx = d3.mean(n_orient, (x) => {
          return Math.cos(g2r(x.theta));
        });
        const my = d3.mean(n_orient, (x) => {
          return Math.sin(g2r(x.theta));
        });
        theta_orient = r2g(Math.atan2(my, mx));
      }

      if (L_attract > 0) {
        const mx = d3.mean(n_attract, (d) => {
          return d.x;
        });
        const my = d3.mean(n_attract, (d) => {
          return d.y;
        });
        theta_attract = r2g(Math.atan2(my - agent.y, mx - agent.x));
      }

      // this is the anticipated direction
      wanted_x = 0.5 * (Math.cos(g2r(theta_orient)) + Math.cos(g2r(theta_attract)));
      wanted_y = 0.5 * (Math.sin(g2r(theta_orient)) + Math.sin(g2r(theta_attract)));
    }

    // this is the update rule, epsilon is the amount of change towards the target direction
    const new_x = Math.cos(g2r(agent.theta)) + epsilon * wanted_x;
    const new_y = Math.sin(g2r(agent.theta)) + epsilon * wanted_y;

    agent.theta = r2g(Math.atan2(new_y, new_x));
  }

  // あまりにも計算量が多いので改造版（インターアクションをなくす）
  static fixThetaPart2(agent) {
    const baseX = Math.random() > 0.5 ? -1 : 1;
    const baseY = Math.random() > 0.5 ? -1 : 1;

    wanted_x = Math.random() * baseX;
    wanted_y = Math.random() * baseY;

    // this is the update rule, epsilon is the amount of change towards the target direction
    const new_x = Math.cos(g2r(agent.theta)) + epsilon * wanted_x;
    const new_y = Math.sin(g2r(agent.theta)) + epsilon * wanted_y;

    agent.theta = r2g(Math.atan2(new_y, new_x));
  }

  static addNoise(agent) {
    agent.theta = agent.theta + (Math.random() - 0.5) * noise_heading.value;
  }

  static makeAStep(agent, setting) {
    const v = speed.value;
    const phi = g2r(agent.theta);
    let dx = dt * v * agent.speed_var * Math.cos(phi);
    let dy = dt * v * agent.speed_var * Math.sin(phi);

    const x_new = agent.x + dx;
    const y_new = agent.y + dy;

    // this takes care of the boundaries
    if (x_new < 0 || x_new > setting.worldWidth) dx *= -1;
    if (y_new < 0 || y_new > setting.worldHeight) dy *= -1;

    agent.x = agent.x + dx;
    agent.y = agent.y + dy;
    agent.theta = r2g(Math.atan2(dy, dx));
  }
}

export default Swim;
